import { Coin, MsgExecuteContractCompat } from '@injectivelabs/sdk-ts'
import { msgBroadcaster } from '@shared/WalletService'
import { sharedToBalanceInWei } from '@shared/utils/formatter'
import { ALLOCATOR_CONTRACT_ADDRESS } from '@/app/utils/constant'
import { delayPromiseCall } from '@/app/client/utils/async'

export const allocateGauge = async ({
  funds,
  lpDenom,
  endTime,
  startTime
}: {
  funds: Coin[]
  lpDenom: string
  endTime: number
  startTime: number
}) => {
  const tokenStore = useTokenStore()
  const walletStore = useWalletStore()
  const stakingStore = useStakingStore()
  const sharedWalletStore = useSharedWalletStore()

  if (
    !sharedWalletStore.isUserConnected ||
    !sharedWalletStore.defaultSubaccountId
  ) {
    return
  }

  await walletStore.validateAndQueue()

  const formattedFunds = funds.map(({ denom, amount }) => ({
    denom,
    amount: sharedToBalanceInWei({
      value: amount,
      decimalPlaces: tokenStore.tokenByDenomOrSymbol(denom)?.decimals
    }).toFixed()
  }))

  const message = MsgExecuteContractCompat.fromJSON({
    sender: sharedWalletStore.injectiveAddress,
    funds: formattedFunds,
    contractAddress: ALLOCATOR_CONTRACT_ADDRESS,
    exec: {
      action: 'allocate_reward_gauges',
      msg: {
        gauges: [
          {
            lp_token: lpDenom,
            start_timestamp: `${startTime * 1000000}`,
            end_timestamp: `${endTime * 1000000}`,
            reward_tokens: formattedFunds
          }
        ]
      }
    }
  })

  await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  await delayPromiseCall(
    async () => await stakingStore.fetchStakingPools(),
    5 * 1000
  )
}

export const revokeGauge = async (gaugeId: number) => {
  const stakingStore = useStakingStore()
  const sharedWalletStore = useSharedWalletStore()

  const message = MsgExecuteContractCompat.fromJSON({
    sender: sharedWalletStore.injectiveAddress,
    contractAddress: ALLOCATOR_CONTRACT_ADDRESS,
    exec: {
      action: 'revoke_reward_gauge',
      msg: {
        id: gaugeId
      }
    }
  })

  await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  await delayPromiseCall(
    async () => await stakingStore.fetchStakingPools(),
    5 * 1000
  )
}
